export default __webpack_public_path__ + "static/media/iniciar_entrenamiento.d5728971.png";